import { ApiService } from "./ApiService";
import { HttpService } from "./HttpService";

const BASE_URL = `${process.env.VUE_APP_API_BASE_URL}api/`;

export const createHttpClient = (): HttpService => {
  return new ApiService(BASE_URL);
};

export const apiService = createHttpClient();

export * from "./Endpoints";
export * from "./HttpService";
export * from "./types";
